import { createSlice } from "@reduxjs/toolkit";

import { OurAchievementsThunk } from "../Thunk/OurAchievementsThunk";

let initState = {
	reload: true,
	sliders: [],
	error: null,
};

const OurAchievementsReducer = createSlice({
	name: "OurAchievements",

	initialState: initState,
	reducers: {},
	extraReducers: (builder) => {
		builder

			.addCase(OurAchievementsThunk.pending, (state, action) => {
				state.reload = true;
			})
			.addCase(OurAchievementsThunk.fulfilled, (state, action) => {
				state.reload = false;
				state.sliders = action.payload.data;
			});
	},
});
export default OurAchievementsReducer.reducer;
